<template>
  <div class="incestgamesbody">
    <div class="form-check text-center">
      <input class="form-check-input" type="checkbox" v-model="useurl" id="imgmode" />
      <label class="form-check-label" for="imgmode">图片使用外链</label>
    </div>
    <div class="container list">
      <div class="row">
        <div
          class="col-lg-3 col-md-4 col-sm-6 col-xs-12 card"
          v-for="(doc,index) in docs"
          :key="doc.title"
        >
          <h4>{{index+1}}</h4>
          <img v-if="useurl" style="width:100%" :src="doc.imgurl" />
          <img v-else style="width:100%" :src="imgUrl+urlencode(doc.title)+'?token='+token" />
          <div>【标题】：{{doc.title}}</div>
          <div class="cut">
            【detailurl】：
            <a :href="doc.detailurl" target="_blank">{{doc.detailurl}}</a>
          </div>
          <div class="cut">
            【fboomlink】：
            <a :href="doc.fboomlink" target="_blank">{{doc.fboomlink}}</a>
          </div>
          <div class="cut">
            【filejokerlink】：
            <a :href="doc.filejokerlink" target="_blank">{{doc.filejokerlink}}</a>
          </div>
          <div>
            <details>
              <summary>【简介】：</summary>
              <div
                style="overflow:scroll;height:200px"
                v-html="doc.intro.replace(/\\n/g,'').replace(/<img/g,'<img class=img-fluid')"
              ></div>
            </details>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import urlencode from "urlencode";
export default {
  name: "Incestgamesbody",
  props: ["docs", "imgUrl", "token"],
  data(){
    return {
      useurl: false
    }
  },
  methods: {
    urlencode: urlencode
  }
};
</script>
<style scoped>
div.cut {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>